import Pages from "./../pages";
import { Home } from "../public";

export default [
  {
    path: "/dashboard",
    component: Pages.Dashboard,
  },
  {
    path: "/jobs/:mode",
    component: Pages.Jobs,
  },
  {
    path: "/jobs",
    component: Pages.Jobs,
  },
  {
    path: "/todo/:mode",
    component: Pages.Todo,
  },
  {
    path: "/todo",
    component: Pages.Todo,
  },

  {
    path: "/users",
    component: Pages.Users,
  },

  {
    path: "/roles",
    component: Pages.Roles,
  },
  {
    path: "/comrota",
    component: Pages.Rota,
  },

  {
    path: "/resources",
    component: Pages.Resources,
  },

  {
    path: "/userDocument",
    component: Pages.UserDocument,
  },

  {
    path: "/cqc/docviewer/:doc",
    component: Pages.DocViewer,
  },


  {
    path: "/cqc",
    component: Pages.CqcDashboard,
  },

  {
    path: "/leave",
    component: Pages.Leave,
  },
  {
    path: "/attendance",
    component: Pages.Attendence,
  },
  {
    path: "/myrota",
    component: Pages.MyRota,
  },
  {
    path: "/evidences",
    component: Pages.Evidences,
  },
  {
    path: "/myprofile",
    component: Pages.MyProfile,
  },
  {
    path: "/helpmat",
    component: Pages.HelpMatManage,
  },
  {
    path: "/help-materials",
    component: Pages.HelpMaterials,
  },
  {
    path: "/reports",
    component: Pages.Reports,
  },
  {
    path: "/logout",
    component: Pages.Logout,
  },
  {
    path: "/",
    component: Home,
  },
];
